module.exports = __webpack_public_path__ + "img/ieee.6b596378.png";